<template>
  <form
    id="signin"
    role="form"
    action="/signin"
    method="post"
    data-cy="signin-form"
    @submit="validateBeforeSubmit"
  >
    <input
      type="hidden"
      name="csrf_token"
      :value="csrf_token"
    >
    <input
      type="hidden"
      name="redirect"
      :value="redirect"
    >
    <div
      class="form-group"
      :class="{'text-danger': !!errors.emailInput}"
    >
      <label for="emailInput">
        <strong>Email</strong>
      </label>
      <input
        id="emailInput"
        name="email"
        class="form-control form-control-lg"
        :class="{'is-invalid': !!errors.emailInput}"
        type="email"
        placeholder="name@example.com"
        v-bind="email"
        data-cy="signin-email"
      >
      <span
        v-cloak
        v-show="!!errors.emailInput"
        class="invalid-feedback"
      >
        {{ errors.emailInput }}
      </span>
    </div>
    <div
      class="form-group"
      :class="{'text-danger': !!errors.passwordInput}"
    >
      <label for="passwordInput">
        <strong>Password</strong>
      </label>
      <input
        id="passwordInput"
        name="password"
        class="form-control form-control-lg"
        :class="{'is-invalid': !!errors.passwordInput}"
        type="password"
        v-bind="password"
        data-cy="signin-password"
      >
      <span
        v-cloak
        v-show="!!errors.passwordInput"
        class="invalid-feedback"
      >
        {{ errors.passwordInput }}
      </span>
    </div>
    <div class="form-group row flex-items-sm-right">
      <div class="col-md-6">
        <label
          v-awr-tooltip="'Keep me logged in for 30 days'"
          class="custom-control custom-checkbox"
        >
          <input
            name="remember"
            type="checkbox"
            class="custom-control-input"
            data-cy="remember-me-checkbox"
          >
          <span class="custom-control-label">Remember me</span>
        </label>
      </div>
      <div class="col-md-6 text-md-right">
        <a
          href="/password-recovery"
          data-cy="password-recovery-link"
        >Forgot password?</a>
      </div>
    </div>
    <button
      type="submit"
      class="btn btn-primary btn-lg btn-block"
      :disabled="!!errors.emailInput || !!errors.passwordInput || disableSubmit"
      data-cy="signin-button"
    >
      Sign In
    </button>
    <br>
  </form>
</template>

<script>
import { defineComponent, reactive, ref } from 'vue';
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { useAwr } from '@/awr/stores/awr';

export default defineComponent({
  name: 'SignInForm',
  setup() {
    const { handleSubmit, errors, defineInputBinds } = useForm({
      validationSchema: yup.object({
        emailInput: yup.string().email('Please provide a valid email address')
          .required('The email address cannot be empty'),
        passwordInput: yup.string().required('The password cannot be empty').max(250, 'The password must have maximum 250 characters'),
      }),
    });

    const email = ref(defineInputBinds('emailInput'));
    const password = ref(defineInputBinds('passwordInput'));

    return reactive({
      errors,
      email,
      password,
      handleSubmit,
    });
  },
  data() {
    const awr = useAwr();

    return {
      csrf_token: awr.$state.csrfToken,
      redirect: awr.$state.redirect,
      email: '',
      password: '',
    };
  },
  computed: {
    disableSubmit() {
      return !this.email.value || this.email.value.length === 0 || !this.password.value || this.password.value.length === 0;
    },
  },
  methods: {
    validateBeforeSubmit(e) {
      const submit = $('#signin').find(':submit');
      submit.prop('disabled', true);

      function failed() {
        e.preventDefault();
        submit.prop('disabled', false);
      }
    },
  },
});
</script>

<style scoped lang="scss">

</style>
